import React from 'react'

export default function VideoModal({ visible, videoUrl, onClose }) {
  if (!visible || !videoUrl) return null

  return (
    <section className="dialog" role="dialog" aria-modal="true">
      <section className="dialog-main">
        <section className="video-main">
          <video src={videoUrl} controls autoPlay preload="auto" />
        </section>
        <button
          type="button"
          className="dialog-close"
          onClick={onClose}
          aria-label="关闭视频"
        />
      </section>
    </section>
  )
}
